import { ApiError } from '../api/apiMms';

const ImplementHelper = {
  isErrorType(value: any): value is ApiError {
    //magic happens here
    return (
      (value as ApiError).status !== undefined &&
      (value as ApiError).body !== undefined
    );
  },
};

export default ImplementHelper;
